/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathFunctionIcon32Regular = forwardRef('MathFunctionIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M16.75 6a4.5 4.5 0 0 0-4.5 4.5V12h4.5a1 1 0 1 1 0 2h-4.5v6.5a6.5 6.5 0 0 1-6.5 6.5h-.5a1 1 0 1 1 0-2h.5a4.5 4.5 0 0 0 4.5-4.5V14h-3.5a1 1 0 1 1 0-2h3.5v-1.5a6.5 6.5 0 0 1 6.5-6.5h1a1 1 0 1 1 0 2h-1Z" }),
        React.createElement("path", { d: "M26.509 18.261a1 1 0 0 0-1.414-1.414l-3.502 3.502-3.502-3.502a1 1 0 0 0-1.415 1.414l3.502 3.502-3.502 3.502a1 1 0 0 0 1.415 1.414l3.502-3.502 3.502 3.502a1 1 0 0 0 1.414-1.414l-3.502-3.502 3.502-3.502Z" })));
});
